import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    nav: {
      home: 'Home',
      loanRequest: 'Request a Loan',
      creditAnalysis: 'Credit Analysis',
      ourTeam: 'Our Team',
      contact: 'Contact Us'
    },
    hero: {
      title: 'Your Simple and Fast Solution for Auto Financing',
      titleProblem: 'Refused by Your Bank?',
      titleSolution: 'Discover your auto financing options.',
      subtitle: 'Bad credit, bankruptcy, consumer proposal or limited credit history? Our team analyzes your situation and presents the available options, no obligation.',
      allCasesAccepted: 'All Cases Accepted',
      cta: 'See My Options',
      ctaSecondary: 'Talk to an Advisor',
      trustLine: 'Free evaluation \u2022 No obligation \u2022 Quick response'
    },
    about: {
      badge: 'AUTO FINANCING QUEBEC',
      title: 'Credit Auto Reset – 2nd and 3rd Chance Financing',
      description1: 'Get your auto loan in Quebec, even with bad credit or after a bank refusal. At Credit Auto Reset, we offer 2nd and 3rd chance financing solutions accessible to everyone.',
      description2: 'Our team supports you with listening, transparency, and expertise to find a financing plan adapted to your budget and needs.',
      description3: 'Because beyond financing, we help you rebuild your credit and regain confidence. Every approval is a fresh start behind the wheel.',
      badge1: 'Bad credit accepted',
      badge2: '2nd and 3rd chance financing',
      badge3: 'Flexible payments',
      cta: 'Request my auto loan',
      ctaSubtext: 'Free evaluation • No obligation • Quick response'
    },
    features: {
      title: 'Take the First Step Towards Your Next Vehicle!',
      subtitle: 'No matter your situation, we guide you with clear and adapted options.',
      feature1Title: '99% Approvals',
      feature1Desc: 'Nearly all applications are approved thanks to our network',
      feature2Title: '$0 Down Payment',
      feature2Desc: 'Get your vehicle with no initial payment required',
      feature3Title: 'Quality Vehicles',
      feature3Desc: 'Access to a wide selection of reliable vehicles'
    },
    approvalRate: 'Approval Rate',
    partners: {
      title: 'Our Financial Partners'
    },
    reviews: {
      title: 'What Our Customers Say',
      subtitle: 'Real stories from real people who got approved',
      googleRating: 'Google Rating',
      basedOn: 'Based on',
      reviews: 'reviews',
      review1: 'Excellent service! I was approved within 24 hours despite my credit challenges. The team was professional and understanding throughout the entire process.',
      review2: 'I never thought I could get a car loan after my bankruptcy. Credit Auto Reset made it happen! Very grateful for their help and patience.',
      review3: 'Outstanding experience! They worked with my budget and found me the perfect vehicle. Highly recommend for anyone needing second chance financing.',
      review4: 'Great team that truly cares about helping people. They explained everything clearly and got us approved quickly. Thank you so much!',
      review5: 'Professional, friendly, and efficient. Got approved for a better vehicle than I expected. This company delivers on their promises!'
    },
    footer: {
      tagline: 'Your simple and fast solution for auto financing — 2nd and 3rd chance credit.',
      badge1: 'All cases accepted',
      badge2: 'Quick response',
      linksTitle: 'Useful Links',
      home: 'Home',
      creditAnalysis: 'Credit Analysis',
      loanRequest: 'Loan Request',
      ourTeam: 'Our Team',
      contact: 'Contact Us',
      contactTitle: 'Join Us',
      address: '1007 Boul René-Lévesque',
      city: 'Verdun, Quebec',
      postal: 'H3E 0H1',
      showMap: 'Show on map',
      sales: 'Sales',
      hoursTitle: 'Hours',
      hours: {
        monThu: 'Mon-Thu',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        closed: 'Closed'
      },
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy'
    },
    loanForm: {
      title: 'Request an Auto Loan',
      subtitle: 'Fill out this form and our team will contact you within 24 hours.',
      personalInfo: 'Personal Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      financialInfo: 'Financial Information',
      employmentStatus: 'Employment Status',
      employed: 'Employed',
      selfEmployed: 'Self-Employed',
      unemployed: 'Unemployed',
      retired: 'Retired',
      annualIncome: 'Annual Income',
      creditScore: 'Credit Score (if known)',
      vehicleInfo: 'Vehicle Preferences',
      vehicleType: 'Type of Vehicle',
      sedan: 'Sedan',
      suv: 'SUV',
      truck: 'Truck',
      other: 'Other',
      budgetRange: 'Budget Range',
      additionalInfo: 'Additional Information',
      message: 'Tell us about your situation',
      submit: 'Submit Application',
      submitting: 'Submitting...',
      success: 'Application submitted successfully! We will contact you soon.',
      error: 'Error submitting application. Please try again.'
    },
    analysis: {
      title: 'Free Credit Analysis',
      subtitle: 'Understand your credit situation and discover your financing options.',
      description: 'Our free credit analysis helps you understand where you stand and what solutions are available to you. No obligation, completely confidential.',
      formTitle: 'Request Your Credit Analysis',
      benefit1Title: 'Free & Confidential',
      benefit1Desc: 'Your information is secure and private',
      benefit2Title: 'No Obligation',
      benefit2Desc: 'Get insights without any commitment',
      benefit3Title: 'Expert Advice',
      benefit3Desc: 'Personalized recommendations from our team'
    },
    team: {
      title: 'Meet Our Team',
      subtitle: 'Dedicated professionals committed to helping you get approved.',
      description: 'Our experienced team of financing specialists works tirelessly to find the best solutions for your unique situation. With years of experience in second-chance financing, we understand the challenges and know how to overcome them.',
      cta: 'Contact Our Team'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Have questions? We are here to help you!',
      getInTouch: 'Get in Touch',
      visitUs: 'Visit Us',
      callUs: 'Call Us',
      nameLabel: 'Name',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      messageLabel: 'Message',
      sendMessage: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent successfully! We will contact you soon.',
      error: 'Error sending message. Please try again.'
    },
    callback: {
      title: 'Request a Callback',
      subtitle: 'Schedule a time for us to call you',
      description: 'Too busy to call? Let us call you! Choose your preferred time and one of our financing experts will reach out.',
      nameLabel: 'Your Name',
      phoneLabel: 'Phone Number',
      preferredTime: 'Preferred Time',
      morning: 'Morning (9AM - 12PM)',
      afternoon: 'Afternoon (12PM - 5PM)',
      evening: 'Evening (5PM - 8PM)',
      preferredDay: 'Preferred Day',
      today: 'Today',
      tomorrow: 'Tomorrow',
      thisWeek: 'This Week',
      message: 'Anything specific to discuss? (Optional)',
      submit: 'Request Callback',
      submitting: 'Submitting...',
      success: 'Callback request submitted! We will call you at your preferred time.',
      error: 'Error submitting request. Please try again.',
      cta: 'Request a Callback'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      loanRequest: 'Demander un prêt',
      creditAnalysis: 'Analyse de crédit',
      ourTeam: 'Notre Équipe',
      contact: 'Contactez-nous'
    },
    hero: {
      title: 'Votre solution simple et rapide pour le financement automobile',
      titleProblem: 'Refusé par votre banque\u00a0?',
      titleSolution: 'Découvrez vos options de financement auto.',
      subtitle: 'Mauvais crédit, faillite, proposition de consommateur ou peu d\'historique de crédit\u00a0? Notre équipe analyse votre situation et vous présente les options disponibles, sans obligation.',
      allCasesAccepted: 'Tous cas acceptés',
      cta: 'Voir mes options',
      ctaSecondary: 'Parler à un conseiller',
      trustLine: 'Évaluation gratuite \u2022 Sans obligation \u2022 Réponse rapide'
    },
    about: {
      badge: 'FINANCEMENT AUTO QUÉBEC',
      title: 'Crédit Auto Reset – Financement 2e et 3e chance',
      description1: 'Obtenez votre prêt auto au Québec, même avec un mauvais crédit ou après un refus bancaire. Chez Crédit Auto Reset, nous offrons des solutions de financement 2e et 3e chance accessibles à tous.',
      description2: 'Notre équipe vous accompagne avec écoute, transparence et expertise pour trouver un plan de financement adapté à votre budget et à vos besoins.',
      description3: 'Parce qu\'au-delà du financement, nous vous aidons à reconstruire votre crédit et reprendre confiance. Chaque approbation, c\'est un nouveau départ au volant.',
      badge1: 'Mauvais crédit accepté',
      badge2: 'Financement 2e et 3e chance',
      badge3: 'Paiements flexibles',
      cta: 'Demander mon prêt auto',
      ctaSubtext: 'Évaluation gratuite • Sans obligation • Réponse rapide'
    },
    features: {
      title: 'Fais le premier pas vers ton prochain véhicule !',
      subtitle: 'Peu importe ta situation, on te guide avec des options claires et adaptées.',
      feature1Title: '99 % d\'approbations',
      feature1Desc: 'Presque toutes les demandes sont approuvées grâce à notre réseau',
      feature2Title: '0 $ comptant',
      feature2Desc: 'Obtenez votre véhicule sans paiement initial requis',
      feature3Title: 'Véhicules de qualité',
      feature3Desc: 'Accès à une large sélection de véhicules fiables'
    },
    approvalRate: 'Taux d\'approbation',
    partners: {
      title: 'Nos partenaires financiers'
    },
    reviews: {
      title: 'Ce que disent nos clients',
      subtitle: 'Vraies histoires de vraies personnes qui ont été approuvées',
      googleRating: 'Note Google',
      basedOn: 'Basé sur',
      reviews: 'avis',
      review1: 'Excellent service! J\'ai été approuvé en 24 heures malgré mes défis de crédit. L\'équipe était professionnelle et compréhensive tout au long du processus.',
      review2: 'Je ne pensais jamais pouvoir obtenir un prêt auto après ma faillite. Crédit Auto Reset l\'a rendu possible! Très reconnaissant de leur aide et patience.',
      review3: 'Expérience exceptionnelle! Ils ont travaillé avec mon budget et m\'ont trouvé le véhicule parfait. Je recommande fortement pour le financement 2e chance.',
      review4: 'Super équipe qui se soucie vraiment d\'aider les gens. Ils ont tout expliqué clairement et nous ont approuvés rapidement. Merci beaucoup!',
      review5: 'Professionnels, amicaux et efficaces. Approuvé pour un meilleur véhicule que prévu. Cette entreprise tient ses promesses!'
    },
    footer: {
      tagline: 'Votre solution simple et rapide pour le financement auto — 2e et 3e chance au crédit.',
      badge1: 'Tous cas acceptés',
      badge2: 'Réponse rapide',
      linksTitle: 'Liens utiles',
      home: 'Accueil',
      creditAnalysis: 'Analyse de crédit',
      loanRequest: 'Demande de prêt',
      ourTeam: 'Notre équipe',
      contact: 'Contactez-nous',
      contactTitle: 'Nous joindre',
      address: '1007 Boul René-Lévesque',
      city: 'Verdun, Québec',
      postal: 'H3E 0H1',
      showMap: 'Afficher sur la carte',
      sales: 'Ventes',
      hoursTitle: 'Heures d\'ouverture',
      hours: {
        monThu: 'Lun-Jeu',
        friday: 'Vendredi',
        saturday: 'Samedi',
        sunday: 'Dimanche',
        closed: 'Fermé'
      },
      rights: 'Tous droits réservés.',
      privacy: 'Politique de confidentialité'
    },
    loanForm: {
      title: 'Demander un prêt automobile',
      subtitle: 'Remplissez ce formulaire et notre équipe vous contactera dans les 24 heures.',
      personalInfo: 'Informations personnelles',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Courriel',
      phone: 'Téléphone',
      financialInfo: 'Informations financières',
      employmentStatus: 'Statut d\'emploi',
      employed: 'Employé',
      selfEmployed: 'Travailleur autonome',
      unemployed: 'Sans emploi',
      retired: 'Retraité',
      annualIncome: 'Revenu annuel',
      creditScore: 'Score de crédit (si connu)',
      vehicleInfo: 'Préférences de véhicule',
      vehicleType: 'Type de véhicule',
      sedan: 'Berline',
      suv: 'VUS',
      truck: 'Camion',
      other: 'Autre',
      budgetRange: 'Fourchette budgétaire',
      additionalInfo: 'Informations supplémentaires',
      message: 'Parlez-nous de votre situation',
      submit: 'Soumettre la demande',
      submitting: 'Envoi en cours...',
      success: 'Demande soumise avec succès! Nous vous contacterons bientôt.',
      error: 'Erreur lors de la soumission. Veuillez réessayer.'
    },
    analysis: {
      title: 'Analyse de crédit gratuite',
      subtitle: 'Comprenez votre situation de crédit et découvrez vos options de financement.',
      description: 'Notre analyse de crédit gratuite vous aide à comprendre où vous en êtes et quelles solutions s\'offrent à vous. Sans obligation, complètement confidentielle.',
      formTitle: 'Demandez votre analyse de crédit',
      benefit1Title: 'Gratuit et confidentiel',
      benefit1Desc: 'Vos informations sont sécurisées et privées',
      benefit2Title: 'Sans obligation',
      benefit2Desc: 'Obtenez des informations sans engagement',
      benefit3Title: 'Conseils d\'experts',
      benefit3Desc: 'Recommandations personnalisées de notre équipe'
    },
    team: {
      title: 'Rencontrez notre équipe',
      subtitle: 'Des professionnels dévoués pour vous aider à obtenir une approbation.',
      description: 'Notre équipe expérimentée de spécialistes en financement travaille sans relâche pour trouver les meilleures solutions pour votre situation unique. Avec des années d\'expérience en financement de deuxième chance, nous comprenons les défis et savons comment les surmonter.',
      cta: 'Contactez notre équipe'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Des questions? Nous sommes là pour vous aider!',
      getInTouch: 'Entrez en contact',
      visitUs: 'Visitez-nous',
      callUs: 'Appelez-nous',
      nameLabel: 'Nom',
      emailLabel: 'Courriel',
      phoneLabel: 'Téléphone',
      messageLabel: 'Message',
      sendMessage: 'Envoyer le message',
      sending: 'Envoi en cours...',
      success: 'Message envoyé avec succès! Nous vous contacterons bientôt.',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.'
    },
    callback: {
      title: 'Demander un rappel',
      subtitle: 'Planifiez un moment pour que nous vous appelions',
      description: 'Trop occupé pour appeler? Laissez-nous vous appeler! Choisissez votre moment préféré et l\'un de nos experts en financement vous contactera.',
      nameLabel: 'Votre nom',
      phoneLabel: 'Numéro de téléphone',
      preferredTime: 'Heure préférée',
      morning: 'Matin (9h - 12h)',
      afternoon: 'Après-midi (12h - 17h)',
      evening: 'Soir (17h - 20h)',
      preferredDay: 'Jour préféré',
      today: 'Aujourd\'hui',
      tomorrow: 'Demain',
      thisWeek: 'Cette semaine',
      message: 'Quelque chose de spécifique à discuter? (Optionnel)',
      submit: 'Demander un rappel',
      submitting: 'Envoi en cours...',
      success: 'Demande de rappel soumise! Nous vous appellerons à l\'heure convenue.',
      error: 'Erreur lors de la soumission. Veuillez réessayer.',
      cta: 'Demander un rappel'
    }
  }
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'fr' : 'en');
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};